module.exports = __webpack_public_path__ + "img/9.ab188b0a.jpg";